import Vue from 'vue'
import Vuex from 'vuex'
import api from "@/api"
import serach from '@/store/modules/serach.js'
import pub from '@/store/modules/pub.js'
import diagnostic from '@/store/modules/diagnostic.js'
import createPersistedState from 'vuex-persistedstate'
import {screenNewArray} from '@/util/common.js'

import {
  unreadNumber,

} from '@/api/warning/diagnostic'
import {
  messageCenterList,
  messageCentergetDetails

} from '@/api/pubrequst'

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  plugins: [
    createPersistedState({
      key: 'rabbitstore-client',
      paths: ['pub']
    })
  ],
  modules: {
    serach,
    pub,
    diagnostic
  },
  state: {
    spinShow: true,
    dataCenter: {},
    listCollection: {},
    listCustomer: {},
    newsNum: 0,
    userNum: 0,
    dologwidth: "30%",
    clearinput: "",
    fullsreeen: true,
    page: -1,
    queNum: 0,
    list: [],
    articles: []
  },

  mutations: {
    setmessageNum(state, list) {
      state.list = list.map((item) => {
        if (item.messageStatus == "unread") {
          item.messageTitle = item.messageContent
        }
        return item
      })
    },
    setpage(state, page) {
      state.page = page
    },
    setfullsreeen(state, data) {
      //大屏的需求 
      state.fullsreeen = data
    },
    dataCenter(state, data) {

      state.dataCenter = {
        ...state.dataCenter,
        ...data
      };
    },
    listCollection(state, data) {

      state.listCollection = {
        ...state.listCollection,
        ...data
      };
      state.dataCenter = {
        ...state.dataCenter,
        ...data
      };

    },
    newsNum(state, data) {
      state.newsNum = data;
    },
    userNum(state, data) {
      state.userNum = data;
    },
    queNum(state, data) {
      state.queNum = data;
    },

    setarticle(state, data) {
        state.articles =data  ;
    },
    clararticle(state) {
      state.articles = []
    }

  },
  actions: {
    clearcleaction({commit},row) {
      
      messageCentergetDetails(row.id)
        .then(() => {
        this.dispatch("newsNum")
        })
    },
    async setqueNum({
      commit,
      state
    }, typeName) {
      let { data } = await unreadNumber()
      commit("queNum", data);
    },
    async dataCenter({
      commit,
      state
    }, typeName) {
      let datas = {
        size: 200
      }
      let centerForm = {}
      if (typeName) datas.type = typeName

      const {
        data
      } = await api.axss("post", "/ocm-admin/dict/page", datas);
      if (data) {
        centerForm[typeName] = data.records
        commit("dataCenter", centerForm);
      }
    },
    async listCollection({
      commit,
      state
    }, typeName) {

      let datas = {
        size: 200,
        value: ""
      }
      let typeList = {}
      if (typeName) datas.type = typeName

      const {
        data
      } = await api.axss("post", "/ocm-admin/select", datas);
      if (data) {
        typeList[typeName] = data.records
        commit("listCollection", typeList);
      }
    },
    async newsNum({
      commit,
      state
    }) {
      messageCenterList({
        size: 5,
        current: 1,
        messageStatus: "unread",
        messageType:"advise"
      })
        .then((res) => {
          if (res && res.data) {
            const { records, total } = res.data;
            commit("setmessageNum", records)
            commit("newsNum", total)
          }
        })

      messageCenterList({
        size: 100,
        current: 1,
        messageStatus: "unread",
        messageType: "notice",
        noticeStatus:1
      })
        .then((res) => {
          if (res && res.data) {
            commit("setarticle", res.data.records)
          }
        })
    },
    async userNum({
      commit,
      state
    }) {
      let num = 0
      const response = await api.axss("get", "/ocm-admin/registrationApproval/getUntreated")
      if (response && response.data) num = response.data
      commit("userNum", num)

    },
  }
});